export const RIGHT = 'RIGHT';
export const LEFT = 'LEFT';
export const DOWN = 'DOWN';
export const UP = 'UP';

export const CLASSIC = 'classic';
export const HIGHLIGHT = 'highlight';
export const PREMIUM = 'premiumchannel';
export const CATEGORY = 'category';
export const RECORDINGS = 'recordings';
export const MORETOP = 'Carrousellomastop';
export const MOREPOPULAR = 'Carrouselverticalampliado';
export const TALENTS = 'tooncharacter';
export const INFINITE = 'infinite';
export const LIVECHANNEL = 'livechannel';
export const VOID = 'void';
export const MIS_AQUILERES = 'Mis-aquileres';
export const PORGRABAR = 'Por-grabar';
export const PLANSELECTOR = 'planselector';
export const IMAGE = 'premiumimage';
export const ROOT_ID_PLAN_SELECTOR_CARD = 'planselector_planselector_link_'
export const INITIAL_ID_PLAN_SELECTOR_BUTTON_BLUE = 'blue-'


//MUNDIAL
export const MUNDIALSOCCERMATCHER = 'soccermatcher';
export const MUNDIALSOCCERTEAMS = 'soccerteams';
export const MUNDIALPLAYERS = 'soccerPlayers';
export const URLRIBBONMATCHES = '/mundial/vcardmatch/';
export const URLVCARDJPLAYER = '/mundial/vcard-jugador/';
export const URLVCARDDIRECTOR = '/mundial/vcard-director/';
export const COMPLETED = 'COMPLETED'
export const COACH = 'COACH'
export const VCARDMATCH = 'vcardmatch'

export const FAVORITED_API = '/user/favorited';
export const FAVORITED_API_V1 = '/user/v1/favorited';
export const SEEN_API = '/user/seen';
export const SEEN_API_V1 = '/user/v1/seen';
export const RECORDINGS_API = '/recordings';
export const LIVECHANNEL_API = '/user/livechannel';
export const LIVECHANNEL_API_V1 = '/user/v1/livechannel';

export const VISIBLE_NUMBER_HIGHLIGHT = 3;
export const VISIBLE_NUMBER_PREMIUM = 4;
export const VISIBLE_NUMBER_CLASSIC = 5;
export const VISIBLE_NUMBER_CATEGORY = 20;
export const VISIBLE_NUMBER_TALENTS = 7;
export const VISIBLE_NUMBER_POPULAR = 6;
export const VISIBLE_NUMBER_PLAYERS = 6;
export const VISIBLE_NUMBER_TOP = 4;
export const VISIBLE_NUMBER_MUNDIAL_SOCCERMATCHER = 4;
export const EXIT = 'EXIT';
export const AKMPBI = 'akmpbi';
export const PLANSOFFERV2 = 'PlansOfferV2'
export const PLAN_SELECTOR = 'plan_selector'
export const PLANSELECTORGM = 'plan-selector'
export const OFFERS = '/offers?'
export const OFFER_TITLE = 'home_user_offers_one_title'
export const SUPERDESTACADO = 'superdestacado';
export const SUPERDESTACADOS = 'superdestacados';

//constants for HBO
export const LINKED = 'linked';
export const UNLINKED = 'unlinked';
export const PENDING = 'pending';
export const ACTIVATION_FLOW = 'activation_flow';
export const HBO = 'hbo';
export const HBO_SUBSCRIPTION = 'suscripto_hbo';
export const QR_ACTIVATION_CONFIG_HBO_DEFAULT = '{"default": {"config": {"active": {"url": "https://www.clarovideo.com/activatehbo", "tag": "activatehbo", "inactivity_timeout_seconds": 0}}, "pulling_duration_seconds": 5, "qr_retries": 5}}';
export const HBO_ACTIVATION_MODAL_DELAY_MS = 1500;





// WEBPACK FOOTER //
// ./src/components/RibbonNew/constants.js